/**
 * La barre du haut, partagée par la coquille parent et par les réglages.
 *
 * Demandée par Hedi le 6 septembre 2026 : *« pour le dashboard je veux avoir
 * [cinq] tab : Tableau de bord, Baya, Mehdi, À valider, Réglages »*. Les deux
 * prénoms sont des onglets à part entière, et non un détour par le tableau de
 * bord — c'est l'écran d'un enfant qu'on ouvre le plus souvent.
 *
 * **Partagée avec `AdminShell`**, et c'est le point : « Réglages » n'est plus
 * une sortie de l'application vers un autre monde avec un lien « ← retour »,
 * c'est un onglet parmi cinq. La barre reste identique, seul l'onglet actif
 * change, et une rangée de sous-onglets apparaît en dessous.
 *
 * Les prénoms viennent du serveur (`ui/enfants`) plutôt que d'une constante :
 * ce sont deux enfants aujourd'hui, et rien ici ne le suppose.
 */

import { NavLink } from "react-router-dom";

import { useSession } from "@/app/session";
import { useEnfants } from "@/ui/enfants";

const actif = ({ isActive }: { isActive: boolean }) => (isActive ? "is-active" : "");

export function ParentTopNav() {
  const { me, signOut } = useSession();
  const enfants = useEnfants();

  return (
    <header className="topbar">
      <nav className="topbar__nav" aria-label="Navigation">
        <NavLink to="/parents" end className={actif}>
          Tableau de bord
        </NavLink>
        {enfants.map((enfant) => (
          <NavLink
            key={enfant.child_id}
            to={`/parents/enfant/${enfant.child_id}`}
            className={actif}
          >
            {enfant.display_name}
          </NavLink>
        ))}
        <NavLink to="/parents/validation" className={actif}>
          À valider
        </NavLink>
        {/* « Les cahiers » avait ici un onglet à lui (25 septembre 2026), faute
            de quoi la V2 n'avait aucune entrée. Depuis le 27 septembre 2026 les
            cahiers sont l'onglet « Entraînements » de la fiche de chaque enfant
            (`ChildLayout`) : l'enfant se choisit sur cette barre, une fois. */}
        <NavLink to="/reglages" className={actif}>
          Réglages
        </NavLink>
      </nav>
      <div className="topbar__end">
        <span className="topbar__who">{me?.display_name}</span>
        <button type="button" className="btn btn--quiet" onClick={() => void signOut()}>
          Se déconnecter
        </button>
      </div>
    </header>
  );
}
